module.exports = __webpack_public_path__ + "img/dev1.13f91d3f.png";